import React from "react";
import "./GalleryTabs.scss";

export default function GalleryTabs({ tabs, selected, onSelect }) {
  return (
    <div className="gallery-tabs">
      {tabs.map((tab) => (
        <span
          key={tab.value}
          className={`gallery-tabs__tab ${
            selected === tab.value ? "active" : ""
          }`}
          onClick={() => onSelect(tab.value)}
        >
          <p>{tab.label}</p>
        </span>
      ))}
    </div>
  );
}
